<template>
  <div class="addModel">
    <div class="addfrom">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" labelPosition='left'>
        <el-row>
          <el-col :span="24">
            <el-form-item label="部门：" prop="deptId">
                <el-cascader
                class="my-popper"
                popper-class="my-popper"
    :options="tableData"
    v-model="ruleForm.deptId"
    :props="{ checkStrictly: true, value: 'deptId', label: 'name', children: 'child' }"
    clearable></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="ruleForm.name" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="手机号：" prop="phone">
              <el-input v-model="ruleForm.phone" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="登录名：" prop="username">
              <el-input v-model="ruleForm.username" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="性别：" prop="gender">
              <el-radio-group v-model="ruleForm.gender">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="0">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item>
              <div class="remark">* 新用户默认密码为Instrument@2024</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class='footer'>
        <el-button v-waves class="mybtny" @click="submit">确定</el-button>
        <el-button v-waves class="mybtny" @click="resetForm">重置</el-button>
        <el-button v-waves class="mybtnn" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getCompanyInfo } from "@/api/systemApi";
export default {
  data() {
    return {
      tableData: [],
      ruleForm: {
        deptId: "",
        name: "",
        phone: "",
        username: "",
        gender: 1,
        lockFlag: "1",
        delFlag: "0",
        password: "Instrument@2024",
      },
      rules: {
        deptId: [{ required: true, message: "请输入部门", trigger: "blur" }],
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            min: 11,
            max: 11,
            message: "请输入11位有效手机号",
            trigger: "blur",
          },
        ],
        username: [
          { required: true, message: "请输入登录名", trigger: "blur" },
        ],
        gender: [
          { required: true, message: "请选择你的性别", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.ruleForm.nickname = this.ruleForm.name;
          this.$emit("submit", this.ruleForm, true);
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    //获取公司信息
    getInfo() {
      this.tableData = [];
      let params = {
        current: 1,
        size: 300,
      };
      getCompanyInfo(params)
        .then((res) => {
          if (res.code == "200") {
            this.tableData = res.data.records;
          }
        })
        .catch((err) => {
          this.$message.error(err.msg || err.message || "服务器连接失败");
        });
    },
  },
};
</script>

<style lang='less' scoped>
  /deep/  .el-cascader-menu__wrap{
    width: 300px !important;
  }
.addModel {
  .addfrom {
    margin: 0 30px;

    .remark {
      float: left;
      margin-left: -75px;
      color: #999;
    }
  }

  /deep/ .el-button {
    width: 100px;
  }

  /deep/ .el-input__inner {
    width: 260px;
  }

}


 

</style>
<style>
.el-cascader-menu__wrap{
  width: 300px !important;
}
</style>




// WEBPACK FOOTER //
// src/views/usermanage/components/addModel.vue